export const firebaseConfigQa = {
  apiKey: 'AIzaSyD8VKgE5EGQw6J_vpUKhRO9gpqgT-xPDK4',
  authDomain: 'portal-productores-a4d2d.firebaseapp.com',
  projectId: 'portal-productores-a4d2d',
  storageBucket: 'portal-productores-a4d2d.appspot.com',
  messagingSenderId: '682618774072',
  appId: '1:682618774072:web:50d0f69ec52c194012bccd',
  measurementId: 'G-HQXD57F83V',
};
